export function estimateFare({ miles, mobility = "Ambulatory", roundTrip = false }) {
  const baseFare = 25;
  const perMile = 3.25;
  const wheelchairFee = 10;
  const stretcherFee = 45;

  let subtotal = baseFare + perMile * Math.max(2, miles || 0);
  if (mobility === "Wheelchair") subtotal += wheelchairFee;
  if (mobility === "Stretcher") subtotal += stretcherFee;
  if (roundTrip) subtotal *= 1.9;
  return Math.round(subtotal * 100) / 100;
}
